import {useContext, useEffect} from 'react';
import {LoadingScreenIndicatorLayout} from '../../foundation/Layout/LoadingScreenIndicator';
import {AuthContext} from '../../api/context';
import {useNavigate} from 'react-router-dom';

export const HomeScreen = () => {
    const context = useContext(AuthContext);
    const navigateTo = useNavigate();

    useEffect(() => {
        const fetchAndUpdateUserDetails = async () => {
            const sessionDetails = await context?.fetchSessionDetails();
            if (sessionDetails) {
                context?.setUserDetails(sessionDetails);
                const {doesUserHaveWebsite} = sessionDetails;
                if (doesUserHaveWebsite) {
                    navigateTo('/dashboard-screen');
                } else {
                    navigateTo('/onboarding-screen');
                }
            }
        };

        if (context?.userDetails) {
            context.setUserDetails(context.userDetails);
        } else {
            fetchAndUpdateUserDetails();
        }
    }, [context?.userDetails]);

    return <LoadingScreenIndicatorLayout />;
};
